export default {
  data() {
    return {
      ltColumns1: [
        { title: '所有列', field: 'title' }
      ],
      rtColumns1: [
        { title: '显示列', field: 'title' }
      ],
      xlsxFmt: {},
      ranges: {}, // 保存查询组件的输入的查询条件
      calculation: null,
      condition: {}, // 保存 表格筛选条件 range 格式（表头筛选、表格配置筛选）
      allConditions: {}, // 传入后端的查询 range 格式参数
      tableFilterData: {}, // 保存 表头 筛选选中数据，用于初始化选中状态
      sortData: [], // 保存 表格配置 中的排序参数
      tableSort: [], // 保存 表头 中的排序参数
      countFileds: [], // 保存 表格配置 中的计算属性
      allOptions: {}, // 保存 处理查询返回数据的所有筛选条件
      filterList: [], // 保存 表头 选中了的列
      currentFilterField: {}, // 保存 条目过多时选中的当前列
      tableconfigFilters: {},
      tableCountData: [],
      pageSearch: {},
      currentRef: 'xTable',
      showHeader: false
    }
  },
  methods: {
    initPage(pageConfig) {
      const columns = []
      const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const keyInfo = pageConfig[key]
        const defaultFmt = { t: 's' }
        const obj = {
          field: key,
          title: keyInfo.title,
          width: keyInfo.width || 120,
          align: keyInfo.align || 'left',
          filters: [],
          filterMultiple: false,
          params: keyInfo.columnParams,
          formatter: keyInfo.formatter,
          xlsxFmt: Object.assign(defaultFmt, keyInfo.xlsxFmt || {})
        }
        if (keyInfo.slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (keyInfo.describe) {
          obj.field += keyInfo.suffix || '_text'
        }

        columns.push(obj)

        // 验证字段是否有查询权限
        if (keyInfo.unSearchRole && this.$_has(keyInfo.unSearchRole)) {
          return
        }

        if (keyInfo.type) {
          searchField[key] = keyInfo
        }
        if (keyInfo.showDescribeInput) {
          searchField[obj.field] = {
            type: 'input',
            title: keyInfo.describeTitle
          }
        }
      })

      const searchKeys = Object.keys(this.pageSearch)
      if (searchKeys.length) {
        const pageSearch = {}
        searchKeys.forEach(key => {
          if (this.pageSearch[key].unSearchRole && this.$_has(this.pageSearch[key].unSearchRole)) {
            return
          } else {
            pageSearch[key] = this.pageSearch[key]
          }
        })
        Object.assign(pageSearch, searchField)
        this.searchField = pageSearch
      } else {
        this.searchField = searchField
      }
      this.gridOptions.columns = this.gridOptions.columns.concat(columns)
    },
    /**
     * 给计算行添加类名
     */
    rowClassName({ rowIndex }, ref = 'xTable') {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }
      if (this['tableCountData' + lastStr].length) {
        if (this['showHeader' + lastStr]) {
          if (rowIndex === 0) {
            return 'row-yellow'
          }
        } else {
          if (rowIndex === this['gridOptions' + lastStr].data.length - 1) {
            return 'row-yellow'
          }
        }
      }
    },
    /**
     * 表格配置 确认/应用
     */
    tableConfigConfirm({ hiddenvalue, sortData, filters, countFileds, showHeader }, ref = 'xTable') {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }
      if (hiddenvalue.length >= 1) {
        // 字段显示与隐藏
        this['gridOptions' + lastStr].columns.forEach((item, idx) => {
          const index = hiddenvalue.findIndex(v => v.field === item.field)
          if (index < 0) {
            item.visible = false
          } else {
            item.visible = true
          }
        })
      } else {
        this['gridOptions' + lastStr].columns.forEach((item, idx) => {
          item.visible = true
        })
      }

      // 重新加载column
      this.$refs[ref].loadColumn(this['gridOptions' + lastStr].columns)
      // 表格排序
      this['sortData' + lastStr] = this.filedsort(sortData)
      // 计算配置读取
      const countList = countFileds.filter(v => v.count)
      // 更新
      this['countFileds' + lastStr] = countFileds
      const flag = !!this['tableCountData' + lastStr].length
      if (countList.length) {
        // 需要展示计算
        const data = {}
        countList.forEach(item => {
          data[item.field] = this['calculation' + lastStr][item.field][item.count]
        })
        this['tableCountData' + lastStr] = [data]
      } else {
        this['tableCountData' + lastStr] = []
      }

      // 比较过滤条件是否变化 如果变化需要调用查询
      if (this.compareFilters(filters, this['tableconfigFilters' + lastStr])) {
        this['condition' + lastStr] = this.handleFilterCondition(ref)
        // 判断原来的是否有计算,先删除原来的计算
        if (flag) {
          this['showHeader' + lastStr]
            ? this['gridOptions' + lastStr].data.splice(0, 1)
            : this['gridOptions' + lastStr].data.splice(-1)
        }

        showHeader
          ? this['gridOptions' + lastStr].data.unshift(...this['tableCountData' + lastStr])
          : this['gridOptions' + lastStr].data.push(...this['tableCountData' + lastStr])
        this['showHeader' + lastStr] = showHeader
        setTimeout(() => {
          this.setFilter()
        }, 100)
        return
      }

      // 过滤条件读取
      this['tableconfigFilters' + lastStr] = filters
      this['condition' + lastStr] = this.handleFilterCondition(ref)
      this.handleRanges(this.ranges)
      this.queryData(1)
    },
    updateCount(ref = 'xTable') {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }
      // 计算配置读取
      const countList = this['countFileds' + lastStr].filter(v => v.count)
      if (countList.length) {
        // 需要展示计算
        const data = {}
        countList.forEach(item => {
          data[item.field] = this['calculation' + lastStr][item.field][item.count]
        })
        this['tableCountData' + lastStr] = [data]
      } else {
        this['tableCountData' + lastStr] = []
      }
    },
    filedsort(sortData) {
      return sortData.filter(v => v.order).map(item => {
        return {
          field_name: item.field,
          field_sort: item.order === 'asc' ? '' : 'X'
        }
      })
    },
    // 比较过滤条件是否变化，返回true false
    compareFilters(nv, ol) {
      const nKeys = Reflect.ownKeys(nv)
      const oKeys = Reflect.ownKeys(ol).filter(v => v !== '__ob__')
      console.log(nKeys, oKeys)
      // 如果keys长度不一样，返回false
      if (nKeys.length !== oKeys.length) return false
      // 如果长度一样，需要判断值是否一样
      try {
        for (const key of nKeys) {
          if (JSON.stringify(ol[key]) !== JSON.stringify(nv[key])) {
            throw new Error('不一样！')
          }
        }
      } catch (e) {
        return false
      }

      return true
    },
    filterChangeEvt({ filterList, values, column, property }, ref = 'xTable') {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }

      this['filterList' + lastStr] = filterList

      this['condition' + lastStr] = this.handleFilterCondition(ref)

      if (!values.length) {
        delete this['tableFilterData' + lastStr][property]
        this.handleRanges(this.ranges)
        this.queryData(1, this.ranges)
        return
      }

      if (values[0] === 'more-option') {
        this.currentFilterField = column
        this.$refs.CustomFilter.show()
        this.currentRef = ref
        return
      }

      // this.handleRanges(this.ranges)
      this.queryData(1, this.ranges)
    },
    // 确定弹窗过滤
    customeFilter(text) {
      if (!text) return
      let lastStr = this.currentRef?.charAt(this.currentRef.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }

      const keys = Object.keys(this['condition' + lastStr])

      if (!keys.length) {
        const key = this.currentFilterField.field
        this['condition' + lastStr][key] = [
          {
            sign: 'I',
            option: 'EQ',
            low: text,
            high: ''
          }
        ]
      } else {
        keys.forEach(key => {
          if (key === this.currentFilterField.field) {
            this['condition' + lastStr][key].push({
              sign: 'I',
              option: 'EQ',
              low: text,
              high: ''
            })
          } else {
            this['condition' + lastStr][this.currentFilterField.field] = [
              {
                sign: 'I',
                option: 'EQ',
                low: text,
                high: ''
              }
            ]
          }
        })
      }
      this.handleRanges(this.ranges)
      this.queryData(1)
    },
    /**
     * 合并 表头筛选 和 表格配置 中的筛选
     * condtion: {
     *  'field': range[]
     * }
     */
    handleFilterCondition(ref) {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }
      const result = {}
      this['tableSort' + lastStr] = []
      // 处理表格的过滤条件
      this['filterList' + lastStr].forEach(({ property, values }) => {
        // 判断是否是 升降序
        if (['desc', 'asc'].includes(values[0])) {
          this['tableSort' + lastStr].push({
            field_name: property,
            field_sort: values[0] === 'asc' ? '' : 'X'
          })
        } else if (values[0] !== 'more-option') {
          result[property] = [
            {
              sign: 'I',
              option: 'EQ',
              low: values[0] === 'isnull' ? '' : values[0],
              high: ''
            }
          ]
        }
        this['tableFilterData' + lastStr][property] = [
          {
            sign: 'I',
            option: 'EQ',
            low: values[0],
            high: ''
          }
        ]
      })

      // 合并 表头筛选 和 表格配置 中的筛选
      const keys = Object.keys(this['tableconfigFilters' + lastStr])
      if (keys.length) {
        keys.forEach(key => {
          if (result[key]) {
            result[key].push(...this['tableconfigFilters' + lastStr][key])
          } else {
            result[key] = this['tableconfigFilters' + lastStr][key]
          }
        })
      }

      return result
    },
    /**
     * 处理查询条件
     * @param {*} ranges 查询表单的查询条件
     * @param {*} type 默认为查询操作，如果有值 表格过滤操作
     */
    handleRanges(ranges, type) {
      let result
      if (ranges) {
        result = { ...ranges }
      } else {
        result = {}
      }
      Object.assign(result, this.condition)

      // Object.keys(this.condition).forEach(key => {
      //   if (result[key]) {
      //     result[key].push(...this.condition[key])
      //   } else {
      //     result[key] = [...this.condition[key]]
      //   }
      // })
      this.allConditions = result
    },
    setFilter(ref = 'xTable', callback) {
      let lastStr = ref?.charAt(ref.length - 1)
      const $table = this.$refs[ref]
      const moreOption = [{
        label: '条目过多',
        value: 'more-option'
      }]
      if (isNaN(lastStr)) {
        lastStr = ''
      }

      // const keys = Object.keys(this['allOptions' + lastStr]) 这种写法会把所有数字类型字段排除，导致不能对数字类型字段进行排序过滤
      const keys = Object.keys(this['allOptions' + lastStr])

      keys.forEach(async field => {
        const nameColumn = $table.getColumnByField(field)
        const filterOption = this['allOptions' + lastStr][field].filter(v => v !== '')

        const options = [
          { label: '升序', value: 'asc' },
          { label: '降序', value: 'desc' }
        ]
        // 如果有空值，添加一个空值选项
        if (filterOption.length !== this['allOptions' + lastStr][field].length) {
          console.log('添加为空字段', field)
          options.push({
            label: '为空',
            value: 'isnull'
          })
        }
        // 如果条数大于 50条 则使用弹窗输入框进行过滤
        if (filterOption.length >= 50) {
          options.push(...moreOption)
        } else {
          const r = filterOption.map(v => ({ label: v, value: v }))
          callback && callback(field, r)
          options.push(...r)
        }
        // 需要设置选中状态
        if (this['tableFilterData' + lastStr][field]?.length) {
          const index = options.findIndex(v => v.value === this['tableFilterData' + lastStr][field][0].low)
          options[index].checked = true
        }
        // 设置过滤条件
        $table.setFilter(nameColumn, options)
        $table.updateData()
      })
    },
    // 重置计算
    resetCount() {
      this.tableCountData = []
      this?.tableCountData2 && (this.tableCountData2 = [])
    },
    // 处理筛选条件
    filterAllOptions(options, ref = 'xTable', flag = false) {
      const result = {}
      let lastStr = ref?.charAt(ref.length - 1)

      if (isNaN(lastStr)) {
        lastStr = ''
      }
      options.forEach(item => {
        const field_name = flag ? item.field_name : item.field_name.toLowerCase()
        const title = this['gridOptions' + lastStr].columns.find(v => v.field === field_name)?.title
        if (title) {
          if (item.is_more === '1') {
            result[field_name] = Array.from({ length: 50 }).fill('1')
          } else {
            result[field_name] = item.field_data.map(v => v.data)
          }
        }
      })
      return result
    },
    // 过滤计算属性
    filtercalculation(calculation, ref = 'xTable', flag = false) {
      let lastStr = ref?.charAt(ref.length - 1)
      if (isNaN(lastStr)) {
        lastStr = ''
      }
      const result = {}
      const countFields = []
      calculation.forEach(item => {
        const field_name = flag ? item.field_name : item.field_name.toLowerCase()
        const title = this['gridOptions' + lastStr].columns.find(v => v.field === field_name)?.title
        if (title) {
          result[field_name] = item.field_data
          countFields.push({
            field: field_name,
            title,
            count: ''
          })
        }
      })
      // 如果有计算字段，就不需要重新赋值了
      if (this['countFileds' + lastStr].length) {
        return result
      }
      this['countFileds' + lastStr] = countFields
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/tableMixins.js